import { AIFunction } from '@/utils/const';

import { getBasePromptConfig } from './common';
import { ModelIdEnum } from './constants';

export const videoEditModelConfig = [
  {
    modelName: 'Kling V2.6 Pro Motion Control',
    modelValue: ModelIdEnum.VIDEO_EDIT_Kling_v2_6_Pro_Motion_Control,
    iconUrl: '/images/keling2.6proMotion.png',
    description: 'fc.8a02ce63',
    retainPrompt: false,
    formConfig: [
      {
        type: 'file',
        label: 'bc.Upload.Video.Footage',
        key: 'video',
        required: true,
        tooltip: 'fc.c3fe4411',
        creditKey: 'duration',
        credit: true,
        creditRule: 'videoDuration',
        config: {
          type: 'video',
          accept: '.mp4,video/mp4,.mov,video/quicktime',
          tips: 'fc.ffd5960d',
          multiple: false,
          maxCount: 1,
          allowLibrarySelect: true,
          feature: AIFunction.VideoEdit,
          resourceOption: 'Video footage',
          rules: [
            {
              maxSize: 200 * 1024 * 1024,
              minDuration: 3,
              maxDuration: 30,
            },
          ],
        },
      },
      {
        type: 'file',
        label: 'merror.0.5.image',
        key: 'image',
        required: true,
        tooltip: 'fc.8a580e09',
        config: {
          type: 'image',
          accept: '.jpg,.png,.jpeg',
          tips: 'JPG-PNG-WEBP-10MB-300-1-2-5-2-5-1',
          maxCount: 1,
          multiple: false,
          allowLibrarySelect: true,
          feature: AIFunction.VideoEdit,
          resourceOption: 'Video footage',
          rules: [
            {
              maxSize: 10 * 1024 * 1024,
              minResolution: '300*300',
              maxResolution: '5000*5000',
            },
            {
              minAspectRatio: '1:2.5',
              maxAspectRatio: '2.5:1',
            },
          ],
        },
      },
      {
        type: 'select',
        value: 'video',
        label: 'fc.d03eb095',
        key: 'character_orientation',
        required: true,
        tooltip: 'fc.acd3a793',
        config: {
          options: [
            { label: 'Image', value: 'image' },
            { label: 'Video', value: 'video' },
          ],
        },
      },
      {
        type: 'prompt',
        label: 'fc.b9cad419',
        key: 'prompt',
        advanced: true,
        config: {
          maxLength: 2000,
          placeholder: 'fc.3ee3277f',
        },
      },
      {
        type: 'prompt',
        label: 'fc.e9112a82',
        key: 'negative_prompt',
        advanced: true,
        config: {
          maxLength: 2000,
          placeholder: 'fc.842ff798',
        },
      },
      {
        type: 'switch',
        label: 'fc.7f970e36',
        key: 'keep_original_sound',
        value: true,
        advanced: true,
      },
    ],
  },
  {
    modelName: 'Kling Video O1 Std Video Edit',
    modelValue: ModelIdEnum.VIDEO_EDIT_Kling_O1_Video_Edit,
    iconUrl: '/images/kling.png',
    description: 'fc.f1406304',
    formConfig: [
      {
        type: 'file',
        label: 'bc.Upload.Video.Footage',
        key: 'video',
        credit: true,
        required: true,
        creditKey: 'duration',
        creditRule: 'videoDuration',
        config: {
          type: 'video',
          accept: '.mp4,video/mp4,.mov,video/quicktime',
          tips: 'MP4-MOV-3-10s-200-MB',
          multiple: false,
          maxCount: 1,
          allowLibrarySelect: true,
          feature: AIFunction.VideoEdit,
          resourceOption: 'Video footage',
          rules: [
            {
              maxSize: 200 * 1024 * 1024,
              minDuration: 3,
              maxDuration: 10,
            },
          ],
        },
      },
      getBasePromptConfig(AIFunction.VideoEdit),
      {
        type: 'file',
        label: 'merror.0.5.image',
        key: 'images',
        required: true,
        config: {
          type: 'image',
          accept: '.jpg,.png,.jpeg',
          tips: 'JPG-PNG-WEBP-10MB-300-1-2-5-2-5-1',
          maxCount: 1,
          multiple: false,
          allowLibrarySelect: true,
          feature: AIFunction.VideoEdit,
          resourceOption: 'Video footage',
          rules: [
            {
              maxSize: 10 * 1024 * 1024,
              minResolution: '300*300',
              maxResolution: '5000*5000',
            },
            {
              minAspectRatio: '1:2.5',
              maxAspectRatio: '2.5:1',
            },
          ],
        },
      },
      {
        type: 'switch',
        label: 'f179f9317549e72fcd6efbc792bdeee2',
        key: 'keep_original_sound',
        value: true,
      },
    ],
  },
];
